// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CoreXNav-cls1__e7e474bb549f0d5f97d4{/*!*/}.CoreXNav-cls2___1dbd0205a7e65df493b{flex-grow:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CoreXNav-cls1__e7e474bb549f0d5f97d4",
	"cls2": "CoreXNav-cls2___1dbd0205a7e65df493b CoreXNav-cls1__e7e474bb549f0d5f97d4"
};
export default ___CSS_LOADER_EXPORT___;
